<template>
  <div class="fade-in">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-6-desktop is-offset-3-desktop is-paddingless">
              <div class="card">
                <div class="card-content">
                  <h2 class="title">Forgot Password</h2>
                  <form @submit.prevent="onSubmit">
                    <div class="field">
                      <label class="label">Email</label>
                      <div class="control has-icons-left has-icons-right">
                        <input
                          class="input"
                          type="email"
                          v-model="user.email"
                          placeholder="Email"
                          autofocus
                        />
                        <span class="icon is-small is-left">
                          <i class="fa fa-envelope"></i>
                        </span>
                      </div>
                    </div>

                    <div class="field is-grouped">
                      <div class="control">
                        <button
                          :class="[
                            'button',
                            'is-primary',
                            'is-large',
                            { 'is-loading': loading }
                          ]"
                        >
                          Send Email
                        </button>
                      </div>
                      <div class="control">
                        <router-link
                          :to="{ name: 'login' }"
                          class="button is-link"
                          style="margin-top: 8px;"
                          >Login</router-link
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-toastr ref="toastr"></vue-toastr>
    </section>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import AuthService from "@/services/AuthService";

export default {
  name: "forgot-password",

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      user: {
        email: ""
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      AuthService.forgotPassword(this.user.email)
        .then(() => {
          this.loading = false;
          this.$refs.toastr.s(
            "Please check your email for a password reset link."
          );
        })
        .catch(() => {
          this.loading = false;
          this.$refs.toastr.e("Sorry, something went wrong. Please try again.");
        });
    }
  }
};
</script>

<style lang="scss">
.forgot-password {
  .navbar,
  .aside {
    display: none;
  }
  .column.col-content.is-9-desktop.is-10-widescreen.is-three-quarters-tablet.is-mobile {
    width: 100%;
    padding: 0;
  }
  section.section {
    padding: 0;
  }

  .card-content {
    padding: 2.14rem;
  }
  .toast-container {
    top: 3.5rem !important;
  }
}
</style>
